import styled from 'styled-components';

export const SubNav = styled.div`
  font-family: 'Noto Serif', serif;
  margin-bottom: 20px;
  display: flex;
  align-items: center;

  a {
    display: inline-block;
    margin: 0 1.5em;
    padding: 0;
    font-size: 0.9em;
    font-weight: 700;
  }

  a:first-child {
    margin-left: 0;
  }

  a.current-item,
  a.current-item:hover,
  a:hover {
    border-color: #9e9ea6;
    color: #333333;
  }

  a h1 {
    color: #999999;
  }

  a.current-item h1,
  a.current-item:hover h1,
  a:hover h1 {
    color: #333333;
  }

  span {
    font-size:3em;
    color:#999999;
  }

  @media (max-width: 992px) {

    margin-bottom: 0;

    span {
      font-size:1.7em;
    }

  }

  @media (max-width: 767px) {

    a, a:first-child {
      text-align: center;
      margin: 0 8px;
    }

    span {
      font-size:1.2em;
    }

  }

`;



// WEBPACK FOOTER //
// ./src/components/navigation/SubNav.style.js